import React from 'react';
import classnames from 'classnames';
import Modal from 'scy/Modal';
import { LightBackground, MutedBackground } from 'scy/Background';
import { Body } from 'scy/text';
import {
  sansSerifLight,
  sansSerifMedium,
  fontSizeXS,
  secondary,
  highlight
} from 'scy/text/styles.mod.scss';
import { LightHR } from 'scy/HR';
import { TextButton } from 'scy/buttons';
import ProductRow from './ProductRow';
import { flex, flex1 } from 'scy/flex.mod.scss';
import { width100 } from 'scy/utils.mod.scss';
import { inlineBlock } from 'scy/display.mod.scss';
import padding from 'scy/padding.mod.scss';
import margin from 'scy/margin.mod.scss';
import styles from './styles.mod.scss';

export default function ReceiptModal({ isOpen, handleClose, order }) {
  return (
    <Modal
      isOpen={isOpen}
      handleClose={handleClose}
      hideCloseButton
      className={styles.receiptModalContent}
      afterOpenClassName={styles.receiptModalAfterOpen}
    >
      <LightBackground className={styles.receiptModalBackground}>
        <div className={padding.xs}>
          <MutedBackground tag="h1" className={styles.receiptModalHeading}>
            Order Receipt
          </MutedBackground>

          <div className={styles.receiptModalProductContainer}>
            {(order.products || []).map(product => (
              <ProductRow
                key={product.sku_id}
                product={product}
                quantity={order.skus[product.sku_id]}
                showPrice
                className={styles.receiptModalProductRow}
              />
            ))}
          </div>

          {order.line_items && !!order.line_items.length && (
            <div
              className={classnames(
                styles.receiptModalContainer,
                padding.top_xs,
                padding.bottom_md
              )}
            >
              {order.line_items.map(item => (
                <LineItem key={item.title + item.index} {...item} />
              ))}
            </div>
          )}
        </div>

        <LightHR />

        <Body className={padding.bottom_xs}>
          <TextButton
            noUnderline
            onClick={handleClose}
            displayClass={inlineBlock}
            className={classnames(width100, padding.xs)}
          >
            Close
          </TextButton>
        </Body>
      </LightBackground>
    </Modal>
  );
}

function LineItem({ title, display, format }) {
  const isTotal = !!title && title.toLowerCase() === 'total';
  const isPromo = !!format && format.toLowerCase() === 'promo';

  return (
    <div
      className={classnames(
        flex,
        fontSizeXS,
        margin.xs,
        margin.bottom_0,
        isTotal ? sansSerifMedium : `${sansSerifLight} ${secondary}`
      )}
    >
      <div className={flex1}>{title}</div>
      <div className={isPromo ? highlight : null}>{display}</div>
    </div>
  );
}
